import React from "react";
import PropTypes from "prop-types";

import useConstants from "@hooks/useConstants";

const { SITE_NAME } = process.env;

const ProCategories = ({ categories }) => {
	const { header } = useConstants("ProCategoriesViewModel");

	return (
		<React.Fragment>
			<a className="anchor" id="tiles" />
			<div className="landing-section content-visibility-auto contain-size-1000">
				<div className="steps">
					<div className="container-fluid">
						<div className="col-xs-12">
							<h2 className="text-center">{header}</h2>
						</div>
					</div>
				</div>

				<section className="service-select">
					<div className="container-fluid">
						<div className="category-boxes clearfix">
							{categories.map(({ name }) => {
								const hyphenatedName = name.replace(/ /g, "-");
								const printedName = name.ucFirst().replace("Companies", "");
								return (
									<a
										href={`/signup?service=${hyphenatedName}&category=${hyphenatedName}`}
										key={name}
									>
										<div className="card col-xs-6 col-sm-4 col-md-3">
											<div className="image">
												<img
													className="b-lazy"
													src={`//static.${SITE_NAME}.com/assets/images/bg/thumbs/default.png`}
													data-src={`//static.${SITE_NAME}.com/assets/images/bg/thumbs/${hyphenatedName}.jpg`}
													alt={printedName}
												/>
												<div className="name">{printedName}</div>
											</div>
										</div>
									</a>
								);
							})}
						</div>
					</div>
				</section>
			</div>
		</React.Fragment>
	);
};

ProCategories.propTypes = {
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default ProCategories;
